import React from 'react';
import './mass-printing.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Impresión masiva'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
